const LOCALE_STORAGE_KEY = 'build-destroy-locale'
const DEFAULT_LOCALE = 'en'

const LOCALES = {
    en: {
        label: 'English',
        shortLabel: 'EN',
        htmlLang: 'en'
    },
    it: {
        label: 'Italiano',
        shortLabel: 'IT',
        htmlLang: 'it'
    }
}

let currentLocale = DEFAULT_LOCALE

const MESSAGES = {
    en: {
        'defaults.builder': 'Builder',
        'defaults.destroyer': 'Destroyer',
        'defaults.guestBuilder': 'Guest Builder',
        'defaults.myFortress': 'My Fortress',
        'defaults.untitledFortress': 'Untitled Fortress',
        'format.bombs': ({ count }) => `${count} ${count === 1 ? 'bomb' : 'bombs'}`,
        'format.bombsNeeded': ({ count }) => `${count} ${count === 1 ? 'bomb' : 'bombs'} needed`,
        'meta.defaultTitle': 'Build & Destroy | Fortress Duel',
        'meta.defaultDescription': 'Build a fortress around the flag, then break rival builds with a siege launcher in Fortress Duel.',
        'meta.buildDescription': ({ title, builderName }) => `Can you destroy ${title} by ${builderName}?`,
        'meta.resultTitle': ({ destroyerName, title, siteName }) => `${destroyerName} destroyed ${title} | ${siteName}`,
        'meta.resultDescription': ({ bombs }) => `${bombs} to capture the flag.`,
        'share.buildText': ({ title, siteName }) => `Can you destroy "${title}" in ${siteName}?`,
        'share.resultText': ({ destroyerName, title, bombs, siteName }) => `${destroyerName} destroyed "${title}" with ${bombs} in ${siteName}.`,
        'share.attribution': '#vibejam created by @domenicodd',
        'openGraph.destroyedIt': ({ playerName }) => `${playerName} destroyed it`,
        'openGraph.byBuilder': ({ builder }) => `by ${builder}`
    },
    it: {
        'defaults.builder': 'Costruttore',
        'defaults.destroyer': 'Distruttore',
        'defaults.guestBuilder': 'Costruttore ospite',
        'defaults.myFortress': 'La mia fortezza',
        'defaults.untitledFortress': 'Fortezza senza titolo',
        'format.bombs': ({ count }) => `${count} ${count === 1 ? 'bomba' : 'bombe'}`,
        'format.bombsNeeded': ({ count }) => `${count} ${count === 1 ? 'bomba necessaria' : 'bombe necessarie'}`,
        'meta.defaultTitle': 'Build & Destroy | Duello tra fortezze',
        'meta.defaultDescription': 'Costruisci una fortezza attorno alla bandiera, poi abbatti le costruzioni rivali con un lanciatore d\'assedio in Duello tra fortezze.',
        'meta.buildDescription': ({ title, builderName }) => `Riesci a distruggere ${title} di ${builderName}?`,
        'meta.resultTitle': ({ destroyerName, title, siteName }) => `${destroyerName} ha distrutto ${title} | ${siteName}`,
        'meta.resultDescription': ({ bombs }) => `${bombs} per catturare la bandiera.`,
        'share.buildText': ({ title, siteName }) => `Riesci a distruggere "${title}" in ${siteName}?`,
        'share.resultText': ({ destroyerName, title, bombs, siteName }) => `${destroyerName} ha distrutto "${title}" con ${bombs} in ${siteName}.`,
        'share.attribution': '#vibejam creato da @domenicodd',
        'openGraph.destroyedIt': ({ playerName }) => `${playerName} l'ha distrutta`,
        'openGraph.byBuilder': ({ builder }) => `di ${builder}`
    }
}

const EXACT_TRANSLATIONS = {
    it: {
        'Build & Destroy | Fortress Duel': 'Build & Destroy | Duello tra fortezze',
        'Build a fortress around the flag, then break rival builds with a slingshot in Fortress Duel.': 'Costruisci una fortezza attorno alla bandiera, poi abbatti le costruzioni rivali con un lanciatore d\'assedio in Duello tra fortezze.',
        'Build a fortress around the flag, then break rival builds with a siege launcher in Fortress Duel.': 'Costruisci una fortezza attorno alla bandiera, poi abbatti le costruzioni rivali con un lanciatore d\'assedio in Duello tra fortezze.',
        'Build & Destroy': 'Build & Destroy',
        'Build and Destroy': 'Build e Destroy',
        'and': 'e',
        'Fortress Duel': 'Duello tra fortezze',
        'Player profile': 'Profilo giocatore',
        'Open ranks': 'Apri classifiche',
        'Ranks': 'Classifiche',
        'Online arena': 'Arena online',
        'Local arena': 'Arena locale',
        'backend: connected': 'backend: connesso',
        'backend: local demo': 'backend: demo locale',
        'Stack stone, wood, and glass around your flag. Then test rival fortresses with a slingshot and the ammo their choices unlock.': 'Impila pietra, legno e vetro attorno alla bandiera. Poi metti alla prova le fortezze rivali con una fionda e le munizioni sbloccate dalle loro scelte.',
        'Stack stone, wood, and glass around your flag. Then test rival fortresses with a siege launcher and the ammo their choices unlock.': 'Impila pietra, legno e vetro attorno alla bandiera. Poi metti alla prova le fortezze rivali con un lanciatore d\'assedio e le munizioni sbloccate dalle loro scelte.',
        'Choose role': 'Scegli ruolo',
        'Builder Mode': 'Modalità costruttore',
        'Craft a 60-point fortress and protect the flag.': 'Crea una fortezza da 60 punti e proteggi la bandiera.',
        'Play': 'Gioca',
        'Start Builder': 'Inizia costruzione',
        'Destroyer Mode': 'Modalità distruttore',
        'Choose ammo, pull the sling, and capture flags.': 'Scegli le munizioni, tira la fionda e cattura le bandiere.',
        'Choose ammo, aim the launcher, and capture flags.': 'Scegli le munizioni, mira con il lanciatore e cattura le bandiere.',
        'Start Attack': 'Inizia attacco',
        'Duplicate': 'Duplica',
        'Duplicate fortress in builder mode': 'Duplica fortezza in modalità costruttore',
        'Choose a fortress to duplicate.': 'Scegli una fortezza da duplicare.',
        'Fortress actions': 'Azioni fortezza',
        'Retry': 'Riprova',
        'Retry fortress': 'Riprova fortezza',
        'Leaderboard': 'Classifica',
        'Best defenses and cleanest captures.': 'Le difese migliori e le catture più pulite.',
        'Build and service information': 'Informazioni su gioco e servizio',
        'vibe coded by': 'vibe coded da',
        'About': 'Info',
        'Loading shared build...': 'Caricamento costruzione condivisa...',
        'Shared build was not found.': 'Costruzione condivisa non trovata.',
        'The shared map link could not be decoded.': 'Impossibile decodificare il link della mappa condivisa.',

        'Builder controls': 'Comandi costruttore',
        'Open builder kit': 'Apri kit costruttore',
        'Collapse builder kit': 'Comprimi kit costruttore',
        'Kit': 'Kit',
        'Hide': 'Nascondi',
        'Back home': 'Torna alla home',
        'Back': 'Indietro',
        'Build budget': 'Budget costruzione',
        'Budget': 'Budget',
        'Ready to publish.': 'Pronta per la pubblicazione.',
        'Place at least 5 blocks before publishing.': 'Posiziona almeno 5 blocchi prima di pubblicare.',
        'The build is over budget.': 'La costruzione supera il budget.',
        'Blocks Kit': 'Kit blocchi',
        'Stone Kit': 'Kit pietra',
        'Wood Kit': 'Kit legno',
        'Glass Kit': 'Kit vetro',
        'Materials': 'Materiali',
        'Block size': 'Dimensione blocco',
        'Builder actions': 'Azioni costruttore',
        'Actions': 'Azioni',
        'Physics': 'Fisica',
        'Static': 'Statico',
        'Rotate': 'Ruota',
        'Delete': 'Elimina',
        'Clear': 'Svuota',
        'Clear build': 'Svuota costruzione',
        'You\'re about to delete you build': 'Stai per eliminare la tua costruzione',
        'This removes every placed block and resets the flag position.': 'Rimuove ogni blocco posizionato e reimposta la posizione della bandiera.',
        'Delete build': 'Elimina costruzione',
        'Restore saved layout': 'Ripristina layout salvato',
        'Save Fortress': 'Salva fortezza',
        'Testing physics': 'Test fisica',
        'Power-ups': 'Potenziamenti',
        'Build resources': 'Risorse costruzione',
        'Ammo': 'Munizioni',
        'View controls': 'Controlli vista',
        'Enable pan mode': 'Attiva modalità panoramica',
        'Disable pan mode': 'Disattiva modalità panoramica',
        'Zoom out': 'Riduci zoom',
        'Reset view': 'Reimposta vista',
        'Zoom in': 'Aumenta zoom',
        'Fortress Name': 'Nome fortezza',
        'Done': 'Fine',
        'Edit': 'Modifica',
        'Place blocks inside the highlighted build zone.': 'Posiziona i blocchi dentro l\'area di costruzione evidenziata.',
        'Build cleared.': 'Costruzione svuotata.',
        'Pan mode enabled.': 'Modalità panoramica attivata.',
        'Pan mode disabled.': 'Modalità panoramica disattivata.',
        'View reset.': 'Vista reimpostata.',
        'Flag selected.': 'Bandiera selezionata.',
        'That piece would exceed the budget.': 'Quel pezzo supererebbe il budget.',
        'That grid slot is already occupied.': 'Quella casella della griglia è già occupata.',
        'Rotation would overlap another block.': 'La rotazione si sovrapporrebbe a un altro blocco.',
        'Block rotated 45 degrees.': 'Blocco ruotato di 45 gradi.',
        'Block rotated 90 degrees.': 'Blocco ruotato di 90 gradi.',
        'Placement cursor rotated 90 degrees.': 'Cursore di posizionamento ruotato di 90 gradi.',
        'Undone.': 'Annullato.',
        'Redone.': 'Ripristinato.',
        'Undo': 'Annulla',
        'Redo': 'Ripristina',
        'Undo (Ctrl/Cmd+Z)': 'Annulla (Ctrl/Cmd+Z)',
        'Redo (Shift+Ctrl/Cmd+Z)': 'Ripristina (Maiusc+Ctrl/Cmd+Z)',
        'Rotate 90 degrees (Shift for 45)': 'Ruota di 90 gradi (Maiusc per 45)',
        'Press Enter to place the block.': 'Premi Invio per posizionare il blocco.',
        'That move would overlap another block.': 'Quello spostamento si sovrapporrebbe a un altro blocco.',
        'Block moved.': 'Blocco spostato.',
        'Build boundary reached.': 'Limite della costruzione raggiunto.',
        'The flag does not rotate.': 'La bandiera non ruota.',
        'Placement cursor rotated 45 degrees.': 'Cursore di posizionamento ruotato di 45 gradi.',
        'Flag positioned.': 'Bandiera posizionata.',
        'Block positioned.': 'Blocco posizionato.',
        'No blocks on the table yet.': 'Non ci sono ancora blocchi sul tavolo.',
        'Physics off. Static stacking mode enabled.': 'Fisica disattivata. Modalità impilamento statico abilitata.',
        'Physics on. Blocks behave exactly as they will under attack.': 'Fisica attivata. I blocchi si comportano esattamente come durante l\'attacco.',
        'Block deleted.': 'Blocco eliminato.',
        'Fix overlapping or out-of-bounds blocks before publishing.': 'Sistema i blocchi sovrapposti o fuori limite prima di pubblicare.',
        'Testing fortress stability with physics...': 'Test della stabilità della fortezza con la fisica...',
        'The fortress moved during the physics test. Restore the saved layout or edit it until it stands still.': 'La fortezza si è mossa durante il test fisico. Ripristina il layout salvato o modificala finché resta ferma.',
        'Some blocks slid or toppled during the physics test. Restore the saved layout or give them better support.': 'Alcuni blocchi sono scivolati o caduti durante il test fisico. Ripristina il layout salvato o dai loro un supporto migliore.',
        'The flag or blocks took too much damage during the physics test. Restore the saved layout or reinforce the fortress.': 'La bandiera o i blocchi hanno subito troppi danni durante il test fisico. Ripristina il layout salvato o rinforza la fortezza.',
        'Restored the layout from before the physics test.': 'Layout precedente al test fisico ripristinato.',
        'Build recap': 'Riepilogo costruzione',
        'Ready to publish?': 'Pronta per la pubblicazione?',
        'Build title': 'Titolo costruzione',
        'Builder name': 'Nome costruttore',
        'Keep building': 'Continua a costruire',
        'Publish build': 'Pubblica costruzione',
        'Add a builder name to publish.': 'Aggiungi un nome costruttore per pubblicare.',
        'Publishing build...': 'Pubblicazione costruzione...',
        'Published to Neon with share image.': 'Pubblicata su Neon con immagine di condivisione.',
        'Published to Neon. Share image unavailable.': 'Pubblicata su Neon. Immagine di condivisione non disponibile.',
        'Saved locally. Add backend env vars for global sharing.': 'Salvata in locale. Aggiungi le variabili backend per la condivisione globale.',
        'Build published': 'Costruzione pubblicata',
        'Challenge link ready.': 'Link sfida pronto.',
        'Copy link': 'Copia link',
        'Test destroy': 'Prova distruzione',
        'Browse builds': 'Sfoglia costruzioni',
        'Share on X': 'Condividi su X',

        'Loading builds...': 'Caricamento costruzioni...',
        'No builds match this filter yet.': 'Nessuna costruzione corrisponde ancora a questo filtro.',
        'Destroyer gallery': 'Galleria distruttore',
        'Choose a fortress': 'Scegli una fortezza',
        'Build one': 'Costruiscine una',
        'Leaderboards': 'Classifiche',
        'all': 'tutte',
        'low': 'bassa',
        'medium': 'media',
        'high': 'alta',
        'Demo': 'Demo',
        'Local': 'Locale',
        'Public': 'Pubblica',
        'Blocks': 'Blocchi',
        'Bullets': 'Proiettili',
        'Wins': 'Vittorie',
        'Attack': 'Attacca',
        'Home': 'Home',
        'Builds': 'Costruzioni',
        'Leaderboard filters': 'Filtri classifica',
        'Loading leaders...': 'Caricamento classifiche...',
        'No leaderboard scores yet.': 'Nessun punteggio in classifica per ora.',
        'Who holds. Who breaks.': 'Chi resiste. Chi sfonda.',
        'All': 'Tutte',
        'Low': 'Bassa',
        'Medium': 'Media',
        'High': 'Alta',
        'Builder board': 'Classifica costruttori',
        'Best defenses': 'Migliori difese',
        'No builders ranked yet.': 'Nessun costruttore in classifica per ora.',
        'Destroyer board': 'Classifica distruttori',
        'Cleanest captures': 'Catture più pulite',
        'No destroyer wins yet.': 'Nessuna vittoria dei distruttori per ora.',
        'See all': 'Vedi tutti',
        'Show less': 'Mostra meno',
        'Holds': 'Difese',
        'Attacks': 'Attacchi',
        'Best': 'Migliore',
        'Runs': 'Tentativi',
        'Builder': 'Costruttore',
        'Destroyer': 'Distruttore',

        'Destroyer mode': 'Modalità distruttore',
        'Back to builds': 'Torna alle costruzioni',
        'Target fortress': 'Fortezza bersaglio',
        'Target Fortress': 'Fortezza bersaglio',
        'Flag captured': 'Bandiera catturata',
        'Flag exposed': 'Bandiera esposta',
        'Flag guarded': 'Bandiera protetta',
        'The Siege of': "L'assedio di",
        'Dispatch from the front': 'Dispaccio dal fronte',
        'Report from the walls': 'Rapporto dalle mura',
        'raised by': 'eretta da',
        'Walls': 'Mura',
        'Navigation': 'Navigazione',
        'Copy into builder': 'Copia nel costruttore',
        'Copy this fortress into the builder': 'Copia questa fortezza nel costruttore',
        'Out of shot. Retry, or pick another fortress.': 'Colpi finiti. Riprova o scegli un\'altra fortezza.',
        'Run status': 'Stato partita',
        'Score': 'Punteggio',
        'Shots': 'Colpi',
        'Attack controls': 'Comandi attacco',
        'Choose ammo': 'Scegli munizioni',
        'Choose Bullet': 'Scegli proiettile',
        'Open bullet drawer': 'Apri selettore proiettili',
        'Close bullet drawer': 'Chiudi selettore proiettili',
        'More bullets': 'Altri proiettili',
        'unlock in battles': 'si sbloccano in battaglia',
        'Out of bullets': 'Proiettili esauriti',
        'Pull, aim, release!': 'Tira, mira, rilascia!',
        'Aim, hold, release': 'Mira, carica, rilascia',
        'Restart or choose another fortress.': 'Ricomincia o scegli un\'altra fortezza.',
        'Hit weak spots to destroy the fortress!': 'Colpisci i punti deboli per distruggere la fortezza!',
        'Hit weak spots to destroy the fortress.': 'Colpisci i punti deboli per distruggere la fortezza.',
        'Pull farther to launch.': 'Tira più indietro per lanciare.',
        'Hold farther to launch.': 'Carica più indietro per lanciare.',
        'Fortress Strength': 'Forza fortezza',
        'Wood Breaker': 'Spezza legno',
        'Explosive': 'Esplosivo',
        'Great area damage': 'Ottimi danni ad area',
        'Best vs': 'Meglio contro',
        'Weight': 'Peso',
        'Strength': 'Forza',
        'Any block': 'Qualsiasi blocco',
        'No hits yet': 'Nessun colpo ancora',
        'Force chain': 'Catena di forza',
        'Support collapse': 'Crollo del supporto',
        'Flag hit': 'Colpo alla bandiera',
        'Flag': 'Bandiera',

        'Result': 'Risultato',
        'Build survived': 'Costruzione sopravvissuta',
        'The destroyer broke through the defense.': 'Il distruttore ha sfondato la difesa.',
        'The builder kept the flag protected.': 'Il costruttore ha mantenuto protetta la bandiera.',
        'Try again': 'Riprova',
        'More builds': 'Altre costruzioni',
        'Destroyer name': 'Nome distruttore',
        'Record result': 'Registra risultato',
        'Captured': 'Catturata',
        'Held': 'Resistita',
        'Bullets fired': 'Proiettili sparati',
        'Time': 'Tempo',
        'Complexity': 'Complessità',
        'Add a destroyer name to record the result.': 'Aggiungi un nome distruttore per registrare il risultato.',
        'Recording attempt...': 'Registrazione tentativo...',
        'Attempt recorded with share image.': 'Tentativo registrato con immagine di condivisione.',
        'Attempt recorded. Share image unavailable.': 'Tentativo registrato. Immagine di condivisione non disponibile.',
        'Attempt recorded.': 'Tentativo registrato.',
        'Link copied.': 'Link copiato.',
        'Copy failed. The link is selected below.': 'Copia non riuscita. Il link è selezionato qui sotto.',

        'Audio controls': 'Controlli audio',
        'Close audio controls': 'Chiudi controlli audio',
        'Open audio controls': 'Apri controlli audio',
        'Unmute audio': 'Riattiva audio',
        'Mute audio': 'Disattiva audio',
        'Muted': 'Muto',
        'Sound': 'Audio',
        'Music': 'Musica',
        'Music volume': 'Volume musica',
        'FX': 'Effetti',
        'Effects volume': 'Volume effetti',
        'Language': 'Lingua',
        'English': 'Inglese',
        'Italiano': 'Italiano',

        'Close about dialog': 'Chiudi finestra informazioni',
        'Close': 'Chiudi',
        'Fortress Duel is a responsive browser game built with Codex as the coding partner: design direction, implementation,\n                    generated arcade art, and polish all stay editable as regular web code.': 'Fortress Duel è un gioco browser responsive creato con Codex come partner di sviluppo: direzione del design, implementazione, grafica arcade generata e rifinitura restano modificabili come normale codice web.',
        'Fortress Duel is a responsive browser game built with Codex as the coding partner: design direction, implementation, generated arcade art, and polish all stay editable as regular web code.': 'Fortress Duel è un gioco browser responsive creato con Codex come partner di sviluppo: direzione del design, implementazione, grafica arcade generata e rifinitura restano modificabili come normale codice web.',
        'Game engine': 'Motore di gioco',
        'Three.js scene rendering with Planck.js (Box2D) physics for block stacks, projectiles, collisions, and flag capture.': 'Rendering della scena con Three.js e fisica Planck.js (Box2D) per pile di blocchi, proiettili, collisioni e cattura della bandiera.',
        'App shell': 'Shell app',
        'Vite, vanilla JavaScript modules, responsive HTML HUDs, pointer controls, and localStorage player identity fallback.': 'Vite, moduli JavaScript vanilla, HUD HTML responsive, controlli puntatore e identità giocatore di riserva in localStorage.',
        'Hosting': 'Hosting',
        'Node server deployment with Vite assets, API routes, uploaded share images, and local audio delivery.': 'Distribuzione con server Node, asset Vite, route API, immagini di condivisione caricate e audio locale.',
        'Backend': 'Backend',
        'Neon Postgres with the local server API for public fortress publishing, result recording, image uploads, and leaderboard reads.': 'Neon Postgres con l API server locale per pubblicare fortezze pubbliche, registrare risultati, caricare immagini e leggere classifiche.',
        'Art pipeline': 'Pipeline grafica',
        'OpenAI Image 2 generated no-text fantasy arcade assets for panorama, mode cards, leaderboard, and social preview.': 'OpenAI Image 2 ha generato asset fantasy arcade senza testo per panorama, schede modalità, classifica e anteprima social.',
        'Gameplay': 'Gameplay',
        'Builder budgets, material-specific ammo rewards, destroyer shots, derived target stats, and shareable fortress challenges.': 'Budget costruttore, ricompense munizioni specifiche per materiale, colpi del distruttore, statistiche bersaglio derivate e sfide fortezza condivisibili.',
        'Social': 'Social',
        'OpenGraph/Twitter metadata, copyable links, social fallback image, and public ranks for builders and destroyers.': 'Metadati OpenGraph/Twitter, link copiabili, immagine social di riserva e classifiche pubbliche per costruttori e distruttori.',
        'Design goal': 'Obiettivo design',
        'Polished arcade feel: poster-style mode cards, cinematic builder workbench, slingshot attack HUD, and mobile compact controls.': 'Sensazione arcade rifinita: schede modalità stile poster, banco costruttore cinematografico, HUD di attacco con fionda e controlli compatti su mobile.',
        'Vintage siege feel: parchment, ink and brass interface, a wooden builder workbench, a living backdrop, and compact controls on phones.': 'Atmosfera d\'assedio d\'altri tempi: interfaccia di pergamena, inchiostro e ottone, banco da lavoro in legno, uno sfondo vivo e comandi compatti sui telefoni.',
        'Follow @domenicodd': 'Segui @domenicodd',
        'Back to game': 'Torna al gioco',

        'Your name': 'Il tuo nome',
        'X handle': 'Handle X',
        '@optional': '@opzionale',
        'Keyboard builder controls': 'Comandi tastiera costruttore',
        'Arrows': 'Frecce',
        'Move': 'Muovi',
        'Enter': 'Invio',
        'Place': 'Posiziona',
        'Tab': 'Tab',
        'Select': 'Seleziona',
        'Material': 'Materiale',
        'Shape': 'Forma',

        'Square': 'Quadrato',
        'Rectangle': 'Rettangolo',
        'Beam': 'Trave',
        'Stone': 'Pietra',
        'Wood': 'Legno',
        'Glass': 'Vetro',
        'stone': 'pietra',
        'wood': 'legno',
        'glass': 'vetro',
        'Stone Chip': 'Scheggia di pietra',
        'Chip': 'Scheggia',
        'Blast Bomb': 'Bomba esplosiva',
        'Bomb': 'Bomba',
        'Wood Crusher': 'Frantuma legno',
        'Crusher': 'Frantuma',
        'Glass Shatter': 'Frantuma vetro',
        'Shatter': 'Frantuma',
        'Light stone bullet for masonry seams.': 'Proiettile leggero di pietra per le giunture della muratura.',
        'Stone Chip is the starter shot. It is light, quick, and best against stone.': 'Scheggia di pietra è il colpo iniziale. È leggera, rapida e funziona meglio contro la pietra.',
        'Explodes on impact and damages nearby supports.': 'Esplode all\'impatto e danneggia i supporti vicini.',
        'Blast Bombs break clusters. Aim near joints and crowded supports.': 'Le bombe esplosive rompono i gruppi. Mira vicino a giunti e supporti affollati.',
        'Midweight bullet that bites into timber.': 'Proiettile medio che morde il legno.',
        'Wood Crusher is strongest against wooden supports.': 'Frantuma legno è più forte contro i supporti in legno.',
        'Bursts mid-flight into glass-cutting shards.': 'Esplode a metà volo in schegge che tagliano il vetro.',
        'Glass Shatter bursts halfway into five shards (tap to burst early). Shards cut glass and bounce off stone and wood.': 'Frantuma vetro esplode a metà strada in cinque schegge (tocca per farlo esplodere prima). Le schegge tagliano il vetro e rimbalzano su pietra e legno.',
        'Starter Stack': 'Pila iniziale',
        'Glass Crown': 'Corona di vetro',

        'Stone fall': 'Caduta pietra',
        'Wood fall': 'Caduta legno',
        'Glass fall': 'Caduta vetro',
        'Stone stress': 'Stress pietra',
        'Wood stress': 'Stress legno',
        'Glass stress': 'Stress vetro'
    }
}

const PATTERN_TRANSLATIONS = {
    it: [
        [/^Unable to load shared build: (.+)$/u, ([, error]) => `Impossibile caricare la costruzione condivisa: ${error}`],
        [/^Unable to load builds: (.+)$/u, ([, error]) => `Impossibile caricare le costruzioni: ${error}`],
        [/^Unable to load leaderboards: (.+)$/u, ([, error]) => `Impossibile caricare le classifiche: ${error}`],
        [/^Publish failed: (.+)$/u, ([, error]) => `Pubblicazione non riuscita: ${error}`],
        [/^Result could not be recorded: (.+)$/u, ([, error]) => `Impossibile registrare il risultato: ${error}`],
        [/^Duplicated (.+)\.$/u, ([, title]) => `Duplicata ${title}.`],
        [/^(.+) selected\.$/u, ([, value]) => `Hai selezionato ${localizeText(value, 'it')}.`],
        [/^(.+) placed\.$/u, ([, value]) => `${localizeText(value, 'it')} posizionato.`],
        [/^(.+) ready for (.+)\.$/u, ([, bullet, target]) => `${localizeText(bullet, 'it')} pronto contro ${localizeText(target, 'it').toLowerCase()}.`],
        [/^Good against (.+)$/u, ([, target]) => `Efficace contro ${localizeText(target, 'it').toLowerCase()}`],
        [/^(.+) -> Flag$/u, ([, bullet]) => `${localizeText(bullet, 'it')} -> Bandiera`],
        [/^(.+) blast$/u, ([, bullet]) => `Esplosione ${localizeText(bullet, 'it').toLowerCase()}`],
        [/^(.+) clipped Flag$/u, ([, bullet]) => `${localizeText(bullet, 'it')} ha sfiorato la bandiera`],
        [/^(.+) fall$/u, ([, material]) => `Caduta ${localizeText(material, 'it').toLowerCase()}`],
        [/^(.+) stress$/u, ([, material]) => `Stress ${localizeText(material, 'it').toLowerCase()}`],
        [/^Fortress strength (\d+) of 10$/u, ([, value]) => `Forza fortezza ${value} su 10`],
        [/^(.+) fortress preview$/u, ([, title]) => `${title}: anteprima della fortezza`],
        [/^(.+) by (.+)$/u, ([, title, builder]) => `${title} di ${builder}`],
        [/^by (.+)$/u, ([, value]) => `di ${value}`],
        [/^(\d+(?:\.\d+)?) pts$/u, ([, value]) => `${formatLocalizedNumberText(value, 'it')} pt`],
        [/^(\d+(?:\.\d+)?) pts \/ Wt (\d+)$/u, ([, points, weight]) => `${formatLocalizedNumberText(points, 'it')} pt / Peso ${weight}`],
        [/^(.+) \/ ([0-9.]+x[0-9.]+) \/ (\d+(?:\.\d+)?) pts$/u, ([, material, size, points]) => `${localizeText(material, 'it')} / ${size} / ${formatLocalizedNumberText(points, 'it')} pt`],
        [/^(\d+) bombs?$/u, ([, value]) => formatLocalizedBombCount(Number(value), {}, 'it')],
        [/^(\d+) bombs? needed$/u, ([, value]) => formatLocalizedBombCount(Number(value), { needed: true }, 'it')]
    ]
}

const LOCALIZED_ATTRIBUTES = ['aria-label', 'placeholder', 'alt', 'title']

export function getInitialLocale() {
    const urlLocale = getUrlLocale()
    if (urlLocale) {
        return urlLocale
    }

    const savedLocale = readSavedLocale()
    if (savedLocale) {
        return savedLocale
    }

    const browserLocale = typeof navigator === 'undefined'
        ? ''
        : String(navigator.language || navigator.languages?.[0] || '').toLowerCase()

    return browserLocale.startsWith('it') ? 'it' : DEFAULT_LOCALE
}

export function setLocale(locale, options = {}) {
    const normalized = normalizeLocale(locale)
    if (!normalized) {
        return false
    }

    currentLocale = normalized
    if (options.persist !== false) {
        saveLocale(normalized)
    }
    applyDocumentLocale()
    return true
}

export function getLocale() {
    return currentLocale
}

export function getLocaleInfo(locale = currentLocale) {
    return LOCALES[normalizeLocale(locale) || DEFAULT_LOCALE]
}

export function getSupportedLocales() {
    return Object.entries(LOCALES).map(([id, config]) => ({ id, ...config }))
}

export function t(key, vars = {}, locale = currentLocale) {
    const normalized = normalizeLocale(locale) || DEFAULT_LOCALE
    const message = MESSAGES[normalized]?.[key] ?? MESSAGES[DEFAULT_LOCALE]?.[key] ?? key
    return typeof message === 'function'
        ? message(vars)
        : interpolate(message, vars)
}

export function formatLocalizedBombCount(value, options = {}, locale = currentLocale) {
    const count = Number(value) || 0
    return t(options.needed ? 'format.bombsNeeded' : 'format.bombs', { count }, locale)
}

export function localizeText(value, locale = currentLocale) {
    const text = String(value ?? '')
    const normalized = normalizeLocale(locale) || DEFAULT_LOCALE

    if (normalized === DEFAULT_LOCALE || !text.trim()) {
        return text
    }

    const leading = text.match(/^\s*/u)?.[0] || ''
    const trailing = text.match(/\s*$/u)?.[0] || ''
    const trimmed = text.trim().replace(/\s+/gu, ' ')
    const translated = translateTrimmedText(trimmed, normalized)

    return `${leading}${translated}${trailing}`
}

export function localizeHtml(html, locale = currentLocale) {
    const normalized = normalizeLocale(locale) || DEFAULT_LOCALE

    if (normalized === DEFAULT_LOCALE || typeof document === 'undefined') {
        return html
    }

    const template = document.createElement('template')
    template.innerHTML = html
    localizeNode(template.content, normalized)
    return template.innerHTML
}

export function applyDocumentLocale() {
    if (typeof document === 'undefined') {
        return
    }

    document.documentElement.lang = getLocaleInfo(currentLocale).htmlLang
}

function localizeNode(root, locale) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
    const textNodes = []

    while (walker.nextNode()) {
        textNodes.push(walker.currentNode)
    }

    for (const textNode of textNodes) {
        textNode.nodeValue = localizeText(textNode.nodeValue, locale)
    }

    for (const element of root.querySelectorAll('*')) {
        for (const attribute of LOCALIZED_ATTRIBUTES) {
            if (!element.hasAttribute(attribute)) {
                continue
            }

            element.setAttribute(attribute, localizeText(element.getAttribute(attribute), locale))
        }
    }
}

function translateTrimmedText(text, locale) {
    const exact = EXACT_TRANSLATIONS[locale]?.[text]
    if (exact) {
        return exact
    }

    for (const [pattern, replace] of PATTERN_TRANSLATIONS[locale] || []) {
        const match = text.match(pattern)
        if (match) {
            return replace(match)
        }
    }

    return text
}

function formatLocalizedNumberText(value, locale) {
    return locale === 'it'
        ? String(value).replace('.', ',')
        : String(value)
}

function interpolate(message, vars) {
    return String(message).replace(/\{([a-zA-Z0-9_]+)\}/gu, (_, key) => vars[key] ?? '')
}

function getUrlLocale() {
    if (typeof window === 'undefined') {
        return ''
    }

    const locale = normalizeLocale(new URLSearchParams(window.location.search).get('lang'))
    return locale || ''
}

function readSavedLocale() {
    try {
        return normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY)) || ''
    } catch {
        return ''
    }
}

function saveLocale(locale) {
    try {
        localStorage.setItem(LOCALE_STORAGE_KEY, locale)
    } catch {
        // localStorage can be blocked; the in-memory locale still applies.
    }
}

function normalizeLocale(locale) {
    const value = String(locale || '').trim().toLowerCase()
    const shortCode = value.split(/[-_]/u)[0]
    return LOCALES[shortCode] ? shortCode : ''
}
